import React, { Component } from 'react';
import withRouter from '../../with_router.js';
import Account from './account.js';


class User extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }


    render() {

        return (
            <Account
                baseUrl={this.props.baseUrl}
                token={this.props.token}
                apiTimeout={this.props.apiTimeout}
                logEvent={this.props.logEvent}
                setLoading={this.props.setLoading}
                unsetLoading={this.props.unsetLoading}
                setError={this.props.setError}
            />
        )
    }
}

export default withRouter(Account);